import { Component } from '@angular/core';

@Component({
  selector: 'app-order-details-events',
  templateUrl: './order-details-events.component.html',
  styleUrls: ['./order-details-events.component.scss']
})
export class OrderDetailsEventsComponent {

}
